/* index.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDKTcp%7Bborder-radius%3Avar(--ds-radius-medium%2C6px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2V7sgONvrM%7Bborder-width%3Avar(--ds-border-width%2C1px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3hxITi6wH8%7Bborder-style%3Asolid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3vBAKHceTh%7Bborder-color%3Avar(--ds-border-discovery%2C%23af59e1)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3YEZNOdnbC%7Bflex-shrink%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._37wbyuDIqT%7Bjustify-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02ey7F%7Bwidth%3A1pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0Vey7F%7Bheight%3A1pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._30huDKjg0e%7Bborder%3Avar(--ds-border-width%2C1px)%20solid%20transparent%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2mHwu81Y8M%7Bgap%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02N91d%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2O5Vij7dHp%7Bflex-grow%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3138424F84%7Bmargin-top%3Avar(--ds-space-negative-100%2C-8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2sNsIgmnOE%7Bfont%3Avar(--ds-font-body%2Cnormal%20400%2014px%2F20px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._30huDKS6k6%7Bborder%3Avar(--ds-border-width%2C1px)%20solid%20var(--ds-border-input%2C%238c8f97)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDKxmn%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2xIroY98eZ%7Boutline-color%3AcurrentColor%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._497WNwYbGa%7Boutline-style%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2zndICT6kp%7Boutline-width%3Amedium%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1kk5Tkf7mX%7Bfont-weight%3Avar(--ds-font-weight-medium%2C500)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Of8r21Y8M%7Bpadding-top%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ZnuxbgVvo%7Bpadding-right%3Avar(--ds-space-075%2C6px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1wydGW1Y8M%7Bpadding-bottom%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Zuz6Q1Y8M%7Bpadding-left%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0xkEdpnXvL%3Afocus%7Bborder-color%3Avar(--ds-border-focused%2C%234688ec)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0ui43C2Bgz%3Afocus%7Bbox-shadow%3A0%200%200%20var(--ds-border-width%2C1px)%20var(--ds-border-focused%2C%234688ec)%7D");
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { bind } from 'bind-event-listener';
import { useIntl } from 'react-intl';
import IconButton from '@atlaskit/button/icon/button';
import type { EmojiProvider } from '@atlaskit/emoji';
import { ResourcedEmoji } from '@atlaskit/emoji/element';
import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';
import Field from '@atlaskit/form/field';
import Form from '@atlaskit/form/form';
import ViewAllIcon from '@atlaskit/icon/core/align-text-left';
import CheckMarkIcon from '@atlaskit/icon/core/check-mark';
import CrossIcon from '@atlaskit/icon/core/cross';
import DeleteIcon from '@atlaskit/icon/core/delete';
import EditIcon from '@atlaskit/icon/core/edit';
import FolderClosedIcon from '@atlaskit/icon/core/folder-closed';
import MoreIcon from '@atlaskit/icon/core/show-more-horizontal';
import Lozenge from '@atlaskit/lozenge/lozenge';
import ButtonItem from '@atlaskit/menu/button-item';
import MenuGroup from '@atlaskit/menu/menu-group';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Popup } from '@atlaskit/popup/popup';
import { Box } from '@atlaskit/primitives/compiled';
import Spinner from '@atlaskit/spinner/spinner';
import { fetchUserTraits, findTraitValue } from '@atlassian/conversation-assistant-service/services/tap-service';
import type { Space } from '@atlassian/rovo-spaces/controllers/space-store/types';
import { useDeleteSpace } from '@atlassian/rovo-spaces/services/useDeleteSpace';
import { useListSpaces } from '@atlassian/rovo-spaces/services/useListSpaces';
import { useRenameSpace } from '@atlassian/rovo-spaces/services/useRenameSpace';
import { DeleteSpaceModal } from '@atlassian/rovo-spaces/ui/DeleteSpaceModal';
import { createEmojiProvider } from '@atlassian/rovo-spaces/utils/emoji-provider';
import { Z_INDEX_POPUP_COMPONENTS } from '../../../common/constants';
import type { ConversationListProps } from '../../../common/types';
import { ButtonMenuItem, type ButtonMenuItemProps } from '../../../common/ui/button-menu-item';
import { LinkMenuItem } from '../../../common/ui/link-menu-item';
import { GenerativeSpaceIcon } from './generative-space-icon';
import messages from './messages';
const SPACES_LIMIT = 5;
const RECOMMENDED_SPACES_ONBOARDING_TRAIT = 'rovo_ui_recommendedspaces_viewed_first_time';
const TAP_DATE_TRAIT_UNSET_VALUE = '1970-01-01T00:00:00Z';
const TAP_DATE_TRAIT_UNSET_VALUE_WITH_MILLISECONDS = '1970-01-01T00:00:00.000Z';
const hasTraitValue = (value: string | boolean | number | undefined): boolean => value !== undefined && value !== '' && value !== TAP_DATE_TRAIT_UNSET_VALUE && value !== TAP_DATE_TRAIT_UNSET_VALUE_WITH_MILLISECONDS;
const styles = {
  recommendedSpacesDiscoveryWrapper: "_0bjKvDKTcp _2V7sgONvrM _3hxITi6wH8 _3vBAKHceTh"
};
const useShouldHighlightRecommendedSpaces = ({
  userId,
  enabled
}: {
  userId?: string;
  enabled: boolean;
}) => {
  const [shouldHighlight, setShouldHighlight] = useState(false);
  useEffect(() => {
    if (!enabled || !userId) {
      setShouldHighlight(false);
      return;
    }
    let cancelled = false;
    fetchUserTraits(userId).then(traits => {
      if (cancelled) {
        return;
      }
      const recommendedSpacesOnboardingTraitValue = findTraitValue(traits, RECOMMENDED_SPACES_ONBOARDING_TRAIT);
      setShouldHighlight(!hasTraitValue(recommendedSpacesOnboardingTraitValue));
    }).catch(() => {
      if (!cancelled) {
        setShouldHighlight(false);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [enabled, userId]);
  return shouldHighlight;
};
export type SpaceMenuItemsProps = Pick<ConversationListProps, 'onConversationRename' | 'onConversationDelete' | 'onConversationPinToggle' | 'conversations' | 'onSelectConversation' | 'currentConversation'> & {
  cloudId: string;
  userId?: string;
  isADSNavigationEnabled: boolean;
  onSelectSpace?: (space: Space) => void;
  selectedSpaceId?: string;
  product: string;
  experienceId: string;
  isNewAllConversationScreenEnabled?: boolean;
  isSpinnerOverlayConversationIconEnabled?: boolean;
  onSelectRecommendedSpaces?: () => void;
  isRecommendedSpacesSelected?: boolean;
  isViewAllSpacesSelected?: boolean;
  onSpaceDelete?: (space: Space) => void;
  /** Called when the user confirms a rename. newName is the trimmed new name. */
  onSpaceRename?: (space: Space, newName: string) => void;
  /**
   * The host's "start a new chat" handler — same callback as the new-chat
   * button at the top of the side nav. When the user successfully deletes
   * the space they are currently viewing, this is invoked automatically so
   * the host returns the user to a fresh chat (rather than leaving them on
   * a now-deleted view). Hosts that don't pass `selectedSpaceId` will not
   * trigger this behaviour.
   */
  onNewChatButtonClick?: ButtonMenuItemProps['onClick'];
  /**
   * Called after a space is successfully created via the Create Space modal.
   *
   * **Contract:** the HOST owns the optimistic store update. This component
   * does NOT call `addSpace` itself — it just forwards the event upward.
   * See the matching docstring on `RovoSideNavigationProps.onSpaceCreated`
   * for the full contract and the regression-bug context.
   */
  onSpaceCreated?: (space: import('@atlassian/rovo-spaces/controllers/space-store/types').CreateSpaceResponse, emojiId?: string) => void;
  onRecommendedSpacesFirstTimeClick?: () => void;
  /**
   * Called when the user clicks the "View all Rovo spaces" link rendered as a
   * sibling under the Spaces section (mirrors the existing "View all agents"
   * pattern in `agents-items`).
   *
   * Rendering of the link is gated INSIDE this component by the Rovo spaces
   * experiment (not by the presence of this callback), so hosts can pass it
   * unconditionally without risking accidental exposure of an ungated feature.
   * When the experiment is off, the link is hidden even if a callback is provided.
   */
  onViewAllSpacesClick?: () => void;
};
export const SpaceMenuItems = ({
  cloudId,
  userId,
  isADSNavigationEnabled,
  onSelectSpace,
  selectedSpaceId,
  product,
  experienceId,
  onSelectRecommendedSpaces,
  isRecommendedSpacesSelected = false,
  onSpaceDelete,
  onSpaceRename,
  onNewChatButtonClick,
  onViewAllSpacesClick,
  onRecommendedSpacesFirstTimeClick
}: SpaceMenuItemsProps): JSX.Element => {
  const {
    formatMessage
  } = useIntl();
  const {
    spaces,
    isLoading
  } = useListSpaces({
    cloudId,
    product,
    experienceId
  });
  const emojiProvider = useMemo(() => createEmojiProvider(cloudId), [cloudId]);
  const limitedSpaces = spaces.slice(0, SPACES_LIMIT);
  const isRecommendedSpacesOnboardingEnabled = Boolean(userId) && fg('rovo_spaces_onboarding_recommended');
  const shouldShowRecommendedSpacesNewState = useShouldHighlightRecommendedSpaces({
    userId,
    enabled: isRecommendedSpacesOnboardingEnabled
  });
  if (isLoading) {
    return <React.Fragment>
				<Spinner size="small" label={formatMessage(messages.loadingLabel)} />
			</React.Fragment>;
  }
  const recommendedSpacesItem = <LinkMenuItem isADSNavigationEnabled={isADSNavigationEnabled} href="#" isSelected={isRecommendedSpacesSelected} testId="rovo-chat-sidenav-recommended-spaces" onClick={e => {
    e.preventDefault();
    if (shouldShowRecommendedSpacesNewState) {
      onRecommendedSpacesFirstTimeClick?.();
    }
    onSelectRecommendedSpaces?.();
  }} elemBefore={<GenerativeSpaceIcon />} elemAfter={shouldShowRecommendedSpacesNewState ? <Lozenge appearance="discovery">{formatMessage(messages.newLozenge)}</Lozenge> : undefined} appearance={shouldShowRecommendedSpacesNewState ? 'discovery' : 'default'}>
			{formatMessage(messages.recommendedSpaces)}
		</LinkMenuItem>;
  const recommendedSpacesItemWithDiscoveryWrapper = shouldShowRecommendedSpacesNewState && isADSNavigationEnabled ? <div data-testid="rovo-chat-sidenav-recommended-spaces-discovery-wrapper" className={ax([styles.recommendedSpacesDiscoveryWrapper])}>
				{recommendedSpacesItem}
			</div> : recommendedSpacesItem;
  return <React.Fragment>
			{recommendedSpacesItemWithDiscoveryWrapper}
			{limitedSpaces.map(space => <SpaceMenuItem key={space.id} space={space} cloudId={cloudId} product={product} experienceId={experienceId} isSelected={space.id === selectedSpaceId} isADSNavigationEnabled={isADSNavigationEnabled} onSelectSpace={onSelectSpace} emojiProvider={emojiProvider} onSpaceDelete={onSpaceDelete} onSpaceRename={onSpaceRename} onNewChatButtonClick={(onNewChatButtonClick as (() => void) | undefined)} />)}
			{onViewAllSpacesClick && FeatureGates.getExperimentValue('rovo_chat_spaces_experiment', 'isEnabled', false) && <ButtonMenuItem isADSNavigationEnabled={isADSNavigationEnabled} onClick={() => {
      onViewAllSpacesClick();
    }} elemBefore={<ViewAllIcon label="" />}>
						{formatMessage(messages.viewAllSpacesLabel)}
					</ButtonMenuItem>}
		</React.Fragment>;
};
type SpaceMenuItemProps = {
  space: Space;
  cloudId: string;
  product: string;
  experienceId: string;
  isSelected: boolean;
  isADSNavigationEnabled: boolean;
  onSelectSpace?: (space: Space) => void;
  emojiProvider: Promise<EmojiProvider>;
  onSpaceDelete?: (space: Space) => void;
  /** Called when the user confirms a rename. newName is the trimmed new name. */
  onSpaceRename?: (space: Space, newName: string) => void;
  /**
   * Host's "start a new chat" handler. Invoked automatically after a successful
   * delete IF this menu item represents the currently-selected space, so the
   * user is taken off the now-deleted view.
   */
  onNewChatButtonClick?: () => void;
};
const SPACE_TESTID_PREFIX = 'rovo-nav-space-item';
const renameStyles = {
  renameForm: "_30huDKjg0e _3iDTPbQ4SZ",
  innerForm: "_2mHwu81Y8M _39xV02N91d _3iDTPbQ4SZ _0hPCNLDIqT",
  textFieldContainer: "_2O5Vij7dHp _3138424F84",
  textField: "_2sNsIgmnOE _30huDKS6k6 _0bjKvDKxmn _2xIroY98eZ _497WNwYbGa _2zndICT6kp _39xV02N91d _24h04i2Njc _1kk5Tkf7mX _0Of8r21Y8M _1ZnuxbgVvo _1wydGW1Y8M _2Zuz6Q1Y8M _0xkEdpnXvL _0ui43C2Bgz"
};
const spaceItemStyles = {
  emojiTile: "_3YEZNOdnbC _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02ey7F _0jFU0Vey7F"
};
const SpaceMenuItem = ({
  space,
  cloudId,
  product,
  experienceId,
  isSelected,
  isADSNavigationEnabled,
  onSelectSpace,
  emojiProvider,
  onSpaceDelete,
  onSpaceRename,
  onNewChatButtonClick
}: SpaceMenuItemProps): JSX.Element => {
  const {
    formatMessage
  } = useIntl();
  const [isMoreMenuOpen, setIsMoreMenuOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [localSpaceName, setLocalSpaceName] = useState(space.name);
  const formRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const {
    deleteSpace
  } = useDeleteSpace({
    cloudId,
    product,
    experienceId,
    onSuccess: () => {
      // Notify the host first so any host-side bookkeeping (analytics,
      // pubsub, etc.) runs before we trigger the navigation reset below.
      onSpaceDelete?.(space);
      // If the user just deleted the space they were viewing, return them
      // to a fresh chat using the host's existing new-chat handler. This
      // reuses whatever side-effects the host already implements for the
      // new-chat button (e.g. publishing `space-deselected`, navigating
      // to the chat root, etc.) so each host gets the right UX without
      // having to wire any additional callback.
      if (isSelected) {
        onNewChatButtonClick?.();
      }
    }
  });
  const {
    renameSpace
  } = useRenameSpace({
    cloudId,
    product,
    experienceId,
    onSuccess: (updatedSpace, newName) => onSpaceRename?.(updatedSpace, newName)
  });
  const onRenameBtnClicked = useCallback(() => {
    setIsMoreMenuOpen(false);
    setLocalSpaceName(space.name);
    setIsEditing(true);
  }, [space.name]);
  const onSubmitRename = useCallback((value: string) => {
    const trimmed = value.trim();
    if (!trimmed) {
      setIsEditing(false);
      return;
    }
    setIsEditing(false);
    void renameSpace(space.id, trimmed);
  }, [space.id, renameSpace]);
  const onCancelRename = useCallback(() => {
    setIsEditing(false);
  }, []);
  useEffect(() => {
    if (!isEditing) {
      setLocalSpaceName(space.name);
    }
  }, [isEditing, space.name]);
  useEffect(() => {
    if (isEditing) {
      inputRef.current?.focus();
    }
  }, [isEditing]);
  useEffect(() => {
    if (!isEditing) {
      return;
    }
    const handleClickOutside = (event: Event) => {
      if (formRef.current && !formRef.current.contains((event.target as Node))) {
        onCancelRename();
      }
    };
    const unbind = bind(window, {
      type: 'mousedown',
      listener: handleClickOutside,
      options: {
        capture: true
      }
    });
    return unbind;
  }, [isEditing, onCancelRename]);
  const onSpaceItemClick = useCallback((event: React.MouseEvent) => {
    event.preventDefault();
    onSelectSpace?.(space);
  }, [onSelectSpace, space]);
  const icon = space.emoji ? <Box xcss={spaceItemStyles.emojiTile} aria-hidden="true">
			<ResourcedEmoji emojiId={{
      id: space.emoji,
      shortName: ''
    }} emojiProvider={emojiProvider} fitToHeight={16} />
		</Box> : <FolderClosedIcon label="" />;
  const moreButton = <Popup testId={`${SPACE_TESTID_PREFIX}-more-popup-${space.id}`} isOpen={isMoreMenuOpen} onClose={() => setIsMoreMenuOpen(false)} zIndex={Z_INDEX_POPUP_COMPONENTS} placement="bottom-end" content={() => <MenuGroup>
					<ButtonItem testId={`${SPACE_TESTID_PREFIX}-rename-${space.id}`} iconBefore={<EditIcon label="" />} onClick={onRenameBtnClicked}>
						{formatMessage(messages.moreMenuRenameLabel)}
					</ButtonItem>
					<ButtonItem testId={`${SPACE_TESTID_PREFIX}-delete-${space.id}`} iconBefore={<DeleteIcon label="" color={"var(--ds-icon-danger, #C9372C)"} />} onClick={() => {
      setIsMoreMenuOpen(false);
      setIsDeleteModalOpen(true);
    }}>
						{formatMessage(messages.moreMenuDeleteLabel)}
					</ButtonItem>
				</MenuGroup>} trigger={triggerProps => <IconButton {...triggerProps} testId={`${SPACE_TESTID_PREFIX}-more-${space.id}`} icon={() => <MoreIcon label="" size="small" />} appearance="subtle" spacing="compact" onClick={e => {
    e.preventDefault();
    e.stopPropagation();
    setIsMoreMenuOpen(prev => !prev);
  }} label={formatMessage(messages.moreMenuLabel)} />} />;

  // Shared inner content for both form variants
  const renameFormInner = <React.Fragment>
			<Box xcss={renameStyles.textFieldContainer}>
				<Field name="spaceName" defaultValue={localSpaceName}>
					{({
          fieldProps
        }) => <input {...fieldProps} ref={inputRef} aria-label={formatMessage(messages.moreMenuRenameLabel)} onKeyDown={(e: React.KeyboardEvent) => {
          if (e.key === 'Escape') {
            e.preventDefault();
            onCancelRename();
          }
        }} data-testid={`${SPACE_TESTID_PREFIX}-name-edit-${space.id}`} className={ax([renameStyles.textField])} />}
				</Field>
			</Box>
			<IconButton icon={iconProps => <CheckMarkIcon {...iconProps} color={"var(--ds-icon-accent-green, #22A06B)"} />} type="submit" appearance="subtle" shape="circle" spacing="compact" label={formatMessage(messages.confirmRenameLabel)} testId={`${SPACE_TESTID_PREFIX}-rename-confirm-${space.id}`} />
			<IconButton icon={iconProps => <CrossIcon {...iconProps} color={"var(--ds-icon-accent-red, #C9372C)"} />} type="button" onClick={onCancelRename} appearance="subtle" shape="circle" spacing="compact" label={formatMessage(messages.cancelRenameLabel)} testId={`${SPACE_TESTID_PREFIX}-rename-cancel-${space.id}`} />
		</React.Fragment>;
  const renameForm = <div ref={formRef} className={ax([renameStyles.renameForm])}>
			{<Form onSubmit={(data: {
      spaceName: string;
    }) => {
      onSubmitRename(data.spaceName);
    }} formProps={{
      class: renameStyles.innerForm
    }}>
					{renameFormInner}
				</Form>}
		</div>;
  return <React.Fragment>
			{/* DeleteSpaceModal is always mounted so its state is preserved regardless of isEditing */}
			<DeleteSpaceModal space={space} isOpen={isDeleteModalOpen} onClose={() => setIsDeleteModalOpen(false)} onDeleteConfirm={deleteSpace} />
			{isEditing ? renameForm : <React.Fragment>
					<LinkMenuItem isADSNavigationEnabled={isADSNavigationEnabled} href="#" isSelected={isSelected} onClick={onSpaceItemClick} elemBefore={icon} actionsOnHover={moreButton}>
						{localSpaceName}
					</LinkMenuItem>
				</React.Fragment>}
		</React.Fragment>;
};